import { logger } from './logger';

export function isShopifyThemeEditor() {
  if (window['Shopify'] && window['Shopify'].designMode) {
    return window['Shopify'].designMode;
  }
  return false;
}

export function getShop() {
  if (window['Shopify'].shop) return window['Shopify'].shop;
}

export function getPage() {
  if (window['ShopifyAnalytics']) {
    if (window['ShopifyAnalytics'].meta.page) {
      switch (window['ShopifyAnalytics'].meta.page.pageType) {
        case 'product':
          return 'product';
        case 'collection':
          return 'collection';
        case 'home':
          return 'home';

        default:
          if (window.location.pathname.endsWith('/cart')) {
            return 'cart';
          }
          if (window.location.pathname.endsWith('/cart/')) {
            return 'cart';
          }
          return 'unknown';
      }
    }
  }

  if (isShopifyThemeEditor()) {
    if (window.location.pathname.endsWith('/cart')) {
      return 'cart';
    }
    if (window.location.pathname.startsWith('/products/')) {
      return 'product';
    }
  }
  return 'unknown';
}

export function getCurrency() {
  if (window['Shopify'] && window['Shopify'].currency) {
    const { active } = window['Shopify'].currency;
    return active;
  }
  return '';
}

export function getCountryCode() {
  if (window['Shopify']) {
    const { country } = window['Shopify'];
    return country;
  }
  return '';
}

export function getLocale() {
  if (window['Shopify']) {
    const { locale } = window['Shopify'];
    return locale;
  }
  return '';
}

export function getCurrencyRate() {
  if (window['Shopify'] && window['Shopify'].currency) {
    const { rate } = window['Shopify'].currency;
    return rate;
  }
  return '1.0';
}

export function isDraftTheme() {
  if (
    window['Shopify'] &&
    window['Shopify'].theme &&
    window['Shopify'].theme.role
  ) {
    return window['Shopify'].theme.role !== 'main';
  }
  return false;
}

export function getUTMData() {
  try {
    const stringified = sessionStorage.getItem('mr_utm');
    if (stringified) {
      const obj = JSON.parse(stringified);
      if (obj) {
        return obj;
      }
    }
    return {};
  } catch (e) {
    logger.log('error in utm', e);
    // using it instead of logger function to avoid cyclic dependency
    return {};
  }
}

export const getCountry = (countryCode) => {
  if (countryCode) return countryCode;
  return getCountryCode();
};

export function getTheme() {
  if (window['Shopify'] && window['Shopify'].theme) {
    const { id, theme_store_id, role, handle } = window['Shopify'].theme;
    let { name } = window['Shopify'].theme;

    // in case theme store id is null then use shopify boomerang
    if (!theme_store_id && window['BOOMR'] && window['BOOMR'].themeName) {
      name = window['BOOMR'].themeName;
    }

    return { name, id, theme_store_id, role, handle };
  }
  return {};
}
